import React, { HTMLAttributes } from "react";

import {
  Container,
  Description,
  SubContainer,
  Title,
  StyledImg,
} from "./EmptySlate.styles";
import { EmptySlateFooter } from "./EmptySlateFooter";

export interface EmptySlateProps extends HTMLAttributes<HTMLDivElement> {
  src: string;
  alt: string;
  title: string;
  description?: string;
}

export const EmptySlate = ({
  title,
  description,
  src,
  alt,
  children,
  ...rest
}: EmptySlateProps) => {
  return (
    <Container {...rest} role="status">
      <StyledImg src={src} alt={alt} />
      <SubContainer>
        <Title weight="light" variant="Title 1">
          {title}
        </Title>
        {description && (
          <Description color="tertiary" variant="Body 1">
            {description}
          </Description>
        )}

        {children}
      </SubContainer>
    </Container>
  );
};

EmptySlate.Footer = EmptySlateFooter;

EmptySlate.displayName = "EmptySlate";
